// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uitk-header-brand-logo{line-height:0px;padding:8px 12px 8px 0}.uitk-header-brand-logo img{max-inline-size:40vw}@media screen and (max-width: 575px){.uitk-header-brand-logo img{block-size:24px}}@media screen and (min-width: 576px){.uitk-header-brand-logo img{block-size:28px}}", ""]);
// Exports
module.exports = exports;
